import React, { useEffect, useState } from 'react'
import { useNavigate } from 'react-router-dom';
import loginUser from '../firebase/loginUser';

const Login = ({ user }) => {

  const [_user, setUser] = useState({
    password: ''
  })
  const [awaitingPromise, setAwaitingPromise] = useState(false)

  const handleOnChange = (e) => {
    setUser({
      ..._user,
      [e.target.name]: e.target.value
    })
  }
  useEffect(() => {


    return () => {
      setAwaitingPromise(false)
    }
  }, [])


  const navigate = useNavigate()

  const handleSubmit = async (e) => {
    e.preventDefault()
    setAwaitingPromise(true)
    const login = await loginUser(_user.password)
    const milisecondsBetween = new Date("2025-12-31T23:59:59.999Z").getTime() - Date.now()
    if (login.success === 200) {
      document.cookie = `id=${login.user.id}; max-age=${milisecondsBetween} ;SameSite=None; Secure`
      navigate("/", { replace: true })
      // setAwaitingPromise(false)
    }
  }

  return (
    <div className="flex min-h-full flex-col px-6 py-12 lg:px-8">
      <div className="sm:mx-auto sm:w-full sm:max-w-sm">
        {/* <img className="mx-auto h-10 w-auto" src="https://tailwindui.com/img/logos/mark.svg?color=indigo&shade=600" alt="Your Company" /> */}
        <h2 className="mt-10 text-center text-2xl font-bold leading-9 tracking-tight dark:text-white text-gray-900">Logga in</h2>

      </div>

      <div className="mt-10 sm:mx-auto sm:w-full sm:max-w-sm">
        <form onSubmit={handleSubmit} className="space-y-6" action="#" method="POST">
          {/* <div>
            <label htmlFor="email" className="block text-sm font-medium leading-6 text-gray-900 dark:text-white">Epost</label>
            <div className="mt-2">
              <input value={user.email} onChange={handleOnChange} id="email" name="email" type="email" autoComplete="email" required className="block w-full dark:border-slate-800 rounded-md border-0 p-1.5 dark:text-white text-gray-900 shadow-sm ring-1 ring-inset ring-gray-300 placeholder:text-gray-400 focus:ring-2 focus:ring-inset focus:ring-indigo-600 sm:text-sm sm:leading-6" />
            </div>
          </div> */}

          <div>
            <div className="flex items-center justify-between">
              <label htmlFor="password" className="block text-sm font-medium leading-6 text-gray-900 dark:text-white">Kod</label>
            </div>
            <div className="mt-2">
              <input value={user.password} onChange={handleOnChange} id="password" name="password" type="password" autoComplete="current-password" required className="block w-full dark:border-slate-800 rounded-md border-0 p-1.5 dark:text-white text-gray-900 shadow-sm ring-1 ring-inset ring-gray-300 placeholder:text-gray-400 focus:ring-2 focus:ring-inset focus:ring-indigo-600 sm:text-sm sm:leading-6" />
            </div>
          </div>

          <div>

            <button disabled={awaitingPromise} type="submit" className="flex w-full justify-center border rounded-md text-sky-400 bg-indigo-600 dark:bg-indigo-950 dark:border-slate-800 px-3 py-1.5 text-sm font-semibold leading-6 mt-10 shadow-sm hover:bg-indigo-500 focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-indigo-600">
              {awaitingPromise && <svg xmlns="http://www.w3.org/2000/svg" height="24" width="24" viewBox="0 0 512 512" className='stroke-white mr-4 animate-spin'><path fill='#38bdf8' d="M222.7 32.1c5 16.9-4.6 34.8-21.5 39.8-79.3 23.6-137.1 97.1-137.1 184.1 0 106 86 192 192 192s192-86 192-192c0-86.9-57.8-160.4-137.1-184.1-16.9-5-26.6-22.9-21.5-39.8s22.9-26.6 39.8-21.5C434.9 42.1 512 140 512 256 512 397.4 397.4 512 256 512S0 397.4 0 256c0-116 77.1-213.9 182.9-245.4 16.9-5 34.8 4.6 39.8 21.5z" /></svg>}
              {awaitingPromise ? "Loggar in" : "Logga in"}</button>
          </div>

        </form>

        {/* <p className="mt-10 text-center text-sm text-gray-500 cursor-pointer hover:underline" onClick={() => setLogin(false)}>
          Har du inget konto?
        </p> */}
      </div>
    </div>
  )
}

export default Login